<template>
  <section class="booking-steps py-30">
    <div class="container">
      <ul class="d-lg-flex justify-content-center align-items-center list-unstyled">
        <li v-bind:class="{ active: currentPath.includes('/coaches/cage-details') }">
          <h5><router-link to="/coaches/cage-details"><span>1</span>Book a Cage</router-link></h5>
        </li>
        <li v-bind:class="{ active: currentPath.includes('/coaches/cage-order-confirm') }">
          <h5><router-link to="/coaches/cage-order-confirm"><span>2</span>Order Confirmation</router-link></h5>
        </li>
        <li v-bind:class="{ active: currentPath.includes('/coaches/cage-personalinfo') }">
          <h5><router-link to="/coaches/cage-personalinfo"><span>3</span>Personal Information</router-link></h5>
        </li>
        <li v-bind:class="{ active: currentPath.includes('/coaches/cage-checkout') }">
          <h5><router-link to="/coaches/cage-checkout"><span>4</span>Payment</router-link></h5>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      currentPath: this.$route.path, // Initialize currentPath with the current route path
    };
  },
};
</script>